<template lang='pug'>
div(class="modal" role="dialog" tabindex="-1" style="display:block;" aria-hidden="true")
  div(class="modal-dialog modal-dialog-scrollable modal-dialog-centered" role="document")
    div(class="modal-content")
      div(class="modal-header")
        SectionTitle(sectionText="LINE Taiwan 尋找各式查核合作夥伴，國內外各領域專家學者與專業組織。")
      div(class="modal-body")
        .popup-item.popup-item--wrapColumn
          span.popup-text 姓名
          input.popup-input(v-model='params.name' placeholder="請輸入姓名" @input="checkActive")
        .popup-item.popup-item--wrapColumn
          span(:class="alert.email.text") 電子郵件
          input(:class="alert.email.input" v-model='params.email' placeholder="請輸入電子郵件" @input="checkActive")
          span.popup-alertText(v-if="alert.email.alertText" style="bottom: -16px;") 格式不符
        .popup-item.popup-item--wrapColumn
          span.popup-text 標題
          input.popup-input(v-model='params.title' placeholder="請輸入標題" @input="checkActive")
        .popup-item
          textarea.popup-textarea(
            v-model='params.content' 
            rows=4 
            placeholder="請輸入訊息內容" 
            maxlength="200"
            @input="checkActive")
          .popup-alertText(v-if="alert.content.alertText") 已達字數上限
          div(:class="alert.content.counter")
            span.popup-remainingCounter {{params.content.length}}
            span.popup-limitCounter {{ contentLimit }}
        .popup-item
          ImageUploadNameCard(@uploadImg="uploadImg")
        .popup-item.popup-item--wrapColumn
          .popup-check
            input.popup-checkbox(v-model='agree' type="checkbox" @input="checkActive")
            .popup-checkboxToggle
            .popup-paragraphCheck
              | 當您勾選左方選項即表示您同意，台灣連線股份有限公司應合作需要，依據
              a(class="text--bold color--blueCornFlower" href="https://terms.line.me/line_tw_privacy_policy?lang=zh-Hant") 台灣連線股份有限公司隱私權條款
              | ，搜集上方您輸入之姓名與郵件，相關資料僅會作為聯繫使用，並在利用目的結束後刪除相關資訊
          span.popup-extraText 送出表單後，我們會盡快與您聯繫。
        .popup-item
          vue-recaptcha(
            :sitekey="$store.state.recaptchaSiteKey"
            :loadRecaptchaScript="true"
            @verify="onCaptchaVerified"
            @expired="onCaptchaExpired"
          )
      div(class="modal-footer")
        PopupButtonsOnBottom(:isActive="isActive" :isScrollablePopup='true' :isSingleButton='false' @send="send" @cancel="closePopup")
    Loading(loader="dots" :active.sync="isLoading" :is-full-page="false")
</template>
<script>
import SectionTitle from '@/components/modules/section_title/section_title.vue'
import PopupButtonsOnBottom from '@/components/popup/popup-buttons-on-bottom.vue'
import ImageUploadNameCard from '@/components/modules/image_upload/image_upload_name_card.vue'
import Loading from 'vue-loading-overlay';
import { lockBody, unlockBody, checkPopupAlert } from '@/plugins/tool.js'
import $ from 'jquery'
import VueRecaptcha from 'vue-recaptcha'

export default {
  components: {
    SectionTitle,
    PopupButtonsOnBottom,
    ImageUploadNameCard,
    VueRecaptcha,
    Loading
  },
  data() {
    return {
      params: {
        "name": "",
        "email": "",
        "title": "",
        "content": "",
        "bizcard": ""
      },
      alert: {
        content: {
          textarea: "popup-textarea",
          counter: "popup-counter",
          alertText: false
        },
        email: {
          text: "popup-text",
          input: "popup-input",
          alertText: false
        }
      },
      recaptchaResponse: "",
      agree: false,
      contentLimit: 200,
      nameLimit: 20,
      titleLimit: 40,
      recaptchaClicked: false,
      isLoading: false,
      isActive: false,
      hasSent: false
    }
  },
  mounted() {
    lockBody()
  },
  computed: {
    validEmail() {
      if (this.params.email === "") return true
      // eslint-disable-next-line
      var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
      return re.test(String(this.params.email).toLowerCase())
    }
  },
  methods: {
    checkActive() {
      if (this.hasSent) this.checkPopupAlert()
      this.alert.content = checkPopupAlert(this.params.content.length > this.contentLimit, this.alert.content)
      this.params.name = this.params.name.substring(0, this.nameLimit)
      this.params.title = this.params.title.substring(0, this.titleLimit)
      setTimeout(() => {
        if (this.params.name &&
          this.params.email &&
          this.params.title &&
          this.params.content &&
          this.params.content.length <= this.contentLimit &&
          this.params.bizcard &&
          this.agree &&
          this.recaptchaClicked)
          this.isActive = true
        else this.isActive = false
      })
    },
    closePopup() {
      this.hasSent = false
      unlockBody()
      this.$emit("closePopup")
    },
    uploadImg(event) {
      this.params.bizcard = event
      this.checkActive()
    },
    async send() {
      if (!this.isActive) return
      this.hasSent = true
      if (!this.checkPopupAlert()) return
      this.isLoading = true
      this.sendData()
    },
    async sendData() {
      const data = new FormData();
      data.append('name', this.params.name);
      data.append('email', this.params.email);
      data.append('title', this.params.title);
      data.append('content', this.params.content);
      data.append('bizcard', this.params.bizcard);
      data.append('g-recaptcha-response', this.recaptchaResponse)
      let route = this.$store.state.URLs.api + this.$store.state.routes.publicReviewers
      this.$axios.post(route, data, {
        headers: {
          "Authorization": "Bearer " + localStorage.getItem(this.$store.state.storageKeys.token),
          "Content-Type": "multipart/form-data"
        }
      })
      .then(() => {
        this.isLoading = false
        this.$emit("isSuccess")
        this.closePopup()
      })
      .catch(() => {
        this.isLoading = false
        this.$emit("isError")
        this.closePopup()
      })
    },
    onCaptchaVerified(response) {
      this.recaptchaResponse = response
      this.recaptchaClicked = true
      this.checkActive()
    },
    onCaptchaExpired(response) {
      this.recaptchaResponse = response
      this.recaptchaClicked = false
      this.checkActive()
    },
    checkPopupAlert() {
      this.alert.email = checkPopupAlert(!this.validEmail, this.alert.email)
      $(".popup-body--scrollable").scrollTop(0)
      if (!this.validEmail) return false
      else return true
    }
  }
}
</script>
<style scoped src="../../assets/koromo_min.css">
</style>